import React, { FC } from 'react';

import { FavoriteFieldsQueryOperationQuery as FavoriteFieldsQueryOperation } from 'core/graphql';
import { useQuery } from 'shared/hooks';

import { FAVORITE_FIELDS_QUERY } from '../FavoriteField';
import { EntityTypeFieldsAndIndicator } from '../Records/useEntityTypeRecordFields';
import { FavoriteFields } from './FavoriteFields';
import { parseFavoriteRecordFields } from './parsers';

interface FavoriteFieldsContainerProps {
  allRecordsJson: string;
  entityTypeFieldsAndIndicator?: EntityTypeFieldsAndIndicator;
}

export const FavoriteFieldsContainer: FC<
  React.PropsWithChildren<FavoriteFieldsContainerProps>
> = ({ allRecordsJson, entityTypeFieldsAndIndicator }) => {
  const { data, loading } = useQuery<FavoriteFieldsQueryOperation>(
    FAVORITE_FIELDS_QUERY
  );

  const favoriteFields = data?.favoriteFields.objects;
  const favFieldMatches =
    allRecordsJson && favoriteFields?.length
      ? parseFavoriteRecordFields(JSON.parse(allRecordsJson), favoriteFields)
      : undefined;

  return (
    <FavoriteFields
      entityTypeFieldsAndIndicator={entityTypeFieldsAndIndicator}
      fields={favFieldMatches}
      loading={loading}
    />
  );
};
